'use client';
import Image from 'next/image';
import React from 'react';

type Props = {
    title: string;
    alt: string;
    width: number;
    height: number;
    path: any;
    children: any;
    slug: string;
    redirect: any;
    desc: string;
};
const WorkCol: React.FC<Props> = ({ title, alt, width, height, path, desc, slug, redirect }) => {
    return (
        <div className="blog-col">
            <div className="card blog-card gap-2.5 flex flex-col !border-0 relative	hover:border-0">
                <Image
                    src={path}
                    alt={alt}
                    className="card-img-top w-full rounded-10 cursor-pointer"
                    width={width}
                    height={height}
                    onClick={() => redirect(slug)}
                    loading="lazy"
                />
                <div className="card-body gap-2.5 flex flex-col">
                    <h2 className="card-title mb-0 cursor-pointer" onClick={() => redirect(slug)}>
                        {title}
                    </h2>
                    <p className="mb-0 font-medium text-lg leading-[1.4] text-secondary dark:text-secondary line-clamp-3">
                        {desc?.trim().endsWith('.') ? desc : `${desc}.`}
                    </p>

                    {/* <div className="flex gap-2.5 flex-wrap items-center">{children}</div> */}
                </div>
            </div>
        </div>
    );
};

export default WorkCol;
